export function setCssVar(elm: HTMLElement, name: string, value?: string) {
  if (value) elm.style.setProperty(`--${name}`, value);
  return getComputedStyle(elm).getPropertyValue(`--${name}`);
}
